import React from "react";

export default function DonateCancel() {
  return (
    <div style={{ maxWidth: 720, margin: "24px auto", padding: "0 16px" }}>
      <h1>Donation canceled</h1>
      <p>No charge was made. You can try again any time.</p>
      <a href="/donate">Return to Donate</a>
    </div>
  );
}
